import React from "react";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

// CSV Export function
const GenerateCSV = (columns, rows, fileName) => {
  const header = columns.map((col) => col.headerName).join(",");
  const body = rows
    .map((row) =>
      columns
        .map((col) => {
          const value =
            typeof col.valueFormatter === "function"
              ? col.valueFormatter({ value: row[col.field], row })
              : row[col.field];
          return `"${value ?? ""}"`;
        })
        .join(",")
    )
    .join("\n");

  const csvContent = `${header}\n${body}`;
  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.setAttribute("download", `${fileName || "table"}.csv`);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

// TXT Export function
const GenerateTXT = (columns, rows, fileName) => {
  const header = columns.map((col) => col.headerName).join("\t");
  const body = rows
    .map((row) =>
      columns
        .map((col) => {
          const value =
            typeof col.valueFormatter === "function"
              ? col.valueFormatter({ value: row[col.field], row })
              : row[col.field];
          return `${value ?? ""}`;
        })
        .join("\t")
    )
    .join("\n");

  const txtContent = `${header}\n${body}`;
  const blob = new Blob([txtContent], { type: "text/plain;charset=utf-8;" });
  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.setAttribute("download", `${fileName || "table"}.txt`);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

// PDF Export function (actualizado)
const GeneratePDF = (columns, rows, fileName) => {
  const doc = new jsPDF();

  const tableColumn = columns.map((col) => col.headerName);
  const tableRows = rows.map((row) =>
    columns.map((col) => {
      const value =
        typeof col.valueFormatter === "function"
          ? col.valueFormatter({ value: row[col.field], row })
          : row[col.field];
      return value ?? "";
    })
  );

  // ✅ Usamos autoTable como función (no doc.autoTable)
  autoTable(doc, {
    head: [tableColumn],
    body: tableRows,
    theme: "grid",
    styles: { fontSize: 10 },
    headStyles: { fillColor: [240, 240, 240] },
  });

  doc.save(`${fileName || "table"}.pdf`);
};

// Export grouped component
const ExportComponent = {
  GenerateCSV,
  GeneratePDF,
  GenerateTXT,
};

export default ExportComponent;
